module.exports = __webpack_public_path__ + "img/doboztervezes.12052771.jpg";